"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellCheckbox = void 0;
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const emoji_1 = require("../../../ui/_private/emoji");
const styled_1 = require("./styled");
const CellCheckbox = (props) => {
    const { field, checked, className, style, cellClassName, cellStyle } = props;
    const renderCheckbox = (status, idx) => (react_1.default.createElement(styled_1.CheckboxStyled, { checked: status, className: cellClassName, style: cellStyle, key: idx },
        react_1.default.createElement(emoji_1.Emoji, { emoji: field.icon, size: 16 })));
    return Array.isArray(checked) ? (react_1.default.createElement(styled_1.CheckboxWrapperStyled, { className: className, style: style }, (0, lodash_1.compact)(checked).map(renderCheckbox))) : renderCheckbox(checked);
};
exports.CellCheckbox = CellCheckbox;
